import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { deletePromotionalCode } from "../api/deletePromotionalCode";

export const useDeletePromotionalCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deletePromotionalCode(id),
    onSuccess: () => {
      toast.success("Promotional code deleted successfully!");
      queryClient.invalidateQueries({ queryKey: ["promotionalCodes"] });
      queryClient.invalidateQueries({ queryKey: ["promotionalCodeDetails"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to delete promotional code.");
    },
  });
};

